import { render, staticRenderFns } from "./authorbar.vue?vue&type=template&id=1e334b10&scoped=true&"
import script from "./authorbar.vue?vue&type=script&lang=js&"
export * from "./authorbar.vue?vue&type=script&lang=js&"
import style0 from "./authorbar.vue?vue&type=style&index=0&id=1e334b10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e334b10",
  null
  
)

export default component.exports